import runtimeConfig from "./runtimeConfig";

export const config = {
    // api: (process.env.SERVER_URL ? process.env.SERVER_URL  : 'https://ntxcms.herokuapp.com/api'),
    ...runtimeConfig,
};
